import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import LoginLayout from "../layout/login-layout";
import Element from "../pages/elements";
import ForgotPassword from "../pages/forgot-password/index.jsx";
import Login from "../pages/login";
import Organization from "../pages/organization";
import OrganizationAllowance from "../pages/organization/allowance";
import OrganizationBenefits from "../pages/organization/benefit";
import OrganizationOwnership from "../pages/organization/ownership/index";
import OrganizationProfile from "../pages/organization/profile";
import Registration from "../pages/registration/index.jsx";
import ProtectedRoute from "./protectedRoute";

import StatutoryComponents from "../pages/statutory/";
import StatutoryEpf from "../pages/statutory/epf/index";
import StatutoryEsi from "../pages/statutory/esi/index";
import StatutoryGratuity from "../pages/statutory/gratuity/index.jsx";
import StatutoryLabourwelfare from "../pages/statutory/Labour-welfare/statutory-labour-welfare.jsx";
import StatutoryPtax from "../pages/statutory/ptax";

import OrganizationLeave from "../pages/leave";

import Employee from "../pages/employee/add";
import BeneficiaryInfo from "../pages/employee/beneficiary.jsx";
import EmployeeList from "../pages/employee/employeelist/employee-list.jsx";
import FamilyInfo from "../pages/employee/family/index.jsx";
import EmployeepayandAndBenefits from "../pages/employee/pay&benefit/pay-benefits.jsx";
import EmployeePayKyc from "../pages/employee/pay-kyc/index.jsx";

import EmployeeProfile from "../pages/employee/profile/index.jsx";
import EmployeestatutoryKyc from "../pages/employee/statutory-kyc/statutory-kyc.jsx";

import OrganizationDetails from "../pages/organization-details";
import OrgAllowanceInfo from "../pages/organization-details/details-allowance/index.jsx";
import OrgBranchInfo from "../pages/organization-details/details-branch/index.jsx";
import OrgHolidayDetails from "../pages/organization-details/details-holiday/index.jsx";
import OrgLeavesInfo from "../pages/organization-details/leave-details";
import OrgOwnershipInfo from "../pages/organization-details/ownership-info/index.jsx";
import OrgPersonalDetails from "../pages/organization-details/personal-details";

import AdminLayout from "../layout/admin.jsx";
import AdminDashboard from "../pages/admin/dashboard/index.jsx";
import Loan from "../pages/loan";
import StatutorycomplianceInformation from "../pages/statutory/compliance/index.jsx";
import Attendance from "../pages/time-and-attendance/attendance/index.jsx";

import StatutoryBankDetails from "../pages/statutory-details/banking-and-finance.jsx";
import StatutoryComplianceDetails from "../pages/statutory-details/compliance.jsx";
import StatutoryEpfDetails from "../pages/statutory-details/epf.jsx";
import StatutoryEsiDetails from "../pages/statutory-details/esi.jsx";
import StatutoryGratuityActDetails from "../pages/statutory-details/gratuity-act.jsx";
import StatutoryDetails from "../pages/statutory-details/index.jsx";
import StatutoryLabourWelfareFundDetails from "../pages/statutory-details/labour-welfare-fund.jsx";
import StatutoryPtaxStatusDetails from "../pages/statutory-details/p-tax-status.jsx";

import { useAuthContext } from "../context/authContext.js";
import useSnackbar from "../hook/use-snakbar.js";
import EmployeePortalLayout from "../layout/employeeportal.jsx";
import AdminLogin from "../pages/admin/login/index.jsx";
import AdminOrganizationAdd from "../pages/admin/organization/organization-add/index.jsx";
import AdminOrganizationList from "../pages/admin/organization/organization-list";
import AdminAllowanceData from "../pages/admin/settings/allowance-data/index.jsx";
import AdminEsiContribution from "../pages/admin/settings/esi-contribution";
import AdminHolidayManagement from "../pages/admin/settings/holiday-management/index.jsx";
import AdminSettings from "../pages/admin/settings/index.jsx";
import AdminLabourWelfareFund from "../pages/admin/settings/labour-welfare-fund/index.jsx";
import AdminLeaveManagement from "../pages/admin/settings/leave-management/index.jsx";
import AdminPTax from "../pages/admin/settings/p-tax";
import SalaryReport from "../pages/custom-report/salary-report/index.jsx";
import EmployeePortalDashboard from "../pages/employee-portal/dashboard/index.jsx";
import EmPortalHoliday from "../pages/employee-portal/holiday/index.jsx";
import EmPortalLeave from "../pages/employee-portal/leave/index.jsx";
import AboutMe from "../pages/employee-portal/my-profile/about-me/index.jsx";
import BankAccount from "../pages/employee-portal/my-profile/bank-account/index.jsx";
import FamilyDetails from "../pages/employee-portal/my-profile/family-details/index.jsx";
import MyProfile from "../pages/employee-portal/my-profile/index.jsx";
import JobDescription from "../pages/employee-portal/my-profile/job-description/index.jsx";
import Nominee from "../pages/employee-portal/my-profile/nominee/index.jsx";
import EmPortalPayslip from "../pages/employee-portal/payslips/index.jsx";
import EmPortalSalaryStructure from "../pages/employee-portal/salary-structure/index.jsx";
import EmployeeBeneficiary from "../pages/employee/beneficiary/index.jsx";
import EmployeeLeaveManage from "../pages/employee/employee-leave-manage/index.jsx";
import EmpLeaveInformation from "../pages/employee/employee-leave-manage/leave-information/index.jsx";
import EmpLeaveRequest from "../pages/employee/employee-leave-manage/leave-request/index.jsx";
import ExitFormaliti from "../pages/employee/exit-formaliti/index.jsx";
import PayAndBenefitsEmployee from "../pages/employee/pay&benefit/index.jsx";
import OrganizationContractualEmployees from "../pages/leave-policy/contractual-employees/index.jsx";
import OrganizationFullTimeEmployee from "../pages/leave-policy/full-time-employee/index.jsx";
import OrganizationalLeavePolicy from "../pages/leave-policy/index.jsx";
import OrganizationPartTimeEmployee from "../pages/leave-policy/part-time-employees/index.jsx";
import OrganizationProbationaryEmployees from "../pages/leave-policy/probationary-employees/index.jsx";
import OnBoarding from "../pages/onboarding/index.jsx";
import Banking from "../pages/organizational-setup/banking/index.jsx";
import OrganizationalBranch from "../pages/organizational-setup/branch/index.jsx";
import OrganizationDepartment from "../pages/organizational-setup/department/index.jsx";
import OrganizationDesignation from "../pages/organizational-setup/designation";
import HolidayManagement from "../pages/organizational-setup/holiday";
import OrganizationalSetup from "../pages/organizational-setup/index.jsx";
import TimeTracking from "../pages/time-and-attendance/time-tracking/index.jsx";
import { Snackbar } from "../ppui/snackbar.jsx";
import ProtectedRouteAdmin from "./protectedRouteAdmin.js";
// import EmPortalApplyLoan from "../pages/employee-portal/apply-loan/index.jsx";
import { EmployeeContextProvider } from "../context/employee-context.js";
import LayoutFull from "../layout/layout-full.jsx";
import OrganizationView from "../pages/admin/oganization-view";
import OrganizationAccessAdmin from "../pages/admin/oganization-view/access/index.jsx";
import OrganizationAllowaanceForAdmin from "../pages/admin/oganization-view/allowance";
import OrganizationBenefitAdmin from "../pages/admin/oganization-view/benefit";
import OrganizationOwnershipForAdmin from "../pages/admin/oganization-view/ownership";
import OrganizationProfileForAdmin from "../pages/admin/oganization-view/profile";
import OrganizationTableView from "../pages/admin/organization/organization-tableview/index.jsx";
import AttendanceReport from "../pages/custom-report/attendance-report/index.jsx";
import EpfReport from "../pages/custom-report/epf-report/index.jsx";
import EsiReport from "../pages/custom-report/esi-report/index.jsx";
import PayslipReport from "../pages/custom-report/pay-slip-report/index.jsx";
import EmpLeaveWeeklyOff from "../pages/employee/weekly-off/index.jsx";
import OrganizationWeeklyOff from "../pages/leave-policy/weekly-off/index.jsx";
import Payroll from "../pages/payroll/index.jsx";
import OtTracking from "../pages/time-and-attendance/ot-trackingnew/index.jsx";
import PtaxReport from "../pages/custom-report/p-tax-report/index.jsx";
import BankDisbursmentReport from "../pages/custom-report/bank-disbursment-report/index.jsx";

const Loader = React.lazy(() => import("../components/loader"));
const Layout = React.lazy(() => import("../layout"));
const Dashboard = React.lazy(() => import("../pages/dashboard"));


function AppRouter() {

  const {
    snackbarVisible,
    snackbarMessage,
    openSnackbar,
    closeSnackbar,
    snackColor,
  } = useSnackbar();


  const { isNotMount, authLoading } = useAuthContext();
  if (isNotMount || authLoading) {
    return <p>Global loading..........</p>
  }

  return (
    <>
      <Suspense fallback={<Loader />}>
        <Routes>
          {/* Login Routes */}
          <Route path="/" element={<LoginLayout />}>
            <Route index element={<Login />} />
            <Route path="/admin-login" element={<AdminLogin openSnackbar={openSnackbar} />} />
            <Route path="/registration" element={<Registration openSnackbar={openSnackbar} />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
          </Route>
          {/* Authenticated Routes (after login) */}
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Layout />}>
              <Route index path="dashboard" element={<Dashboard />} />
              <Route path="elements" element={<Element />} />
              <Route path="organization" element={<Organization />}>
                <Route
                  index
                  element={<OrganizationProfile />}
                />
                <Route
                  index
                  path="ownership"
                  element={<OrganizationOwnership />}
                />
                <Route
                  index
                  path="allowance"
                  element={<OrganizationAllowance />}
                />
                <Route
                  index
                  path="benefits"
                  element={<OrganizationBenefits />}
                />
              </Route>
              <Route path="statutory" element={<StatutoryComponents />}>
                <Route index element={<StatutoryEpf />} />
                <Route path="esi" element={<StatutoryEsi />} />
                <Route
                  path="gratuity"
                  element={<StatutoryGratuity />}
                />
                <Route path="ptax" element={<StatutoryPtax />} />
                <Route
                  path="labourwelfare"
                  element={<StatutoryLabourwelfare />}
                />
                <Route
                  path="compliance"
                  element={<StatutorycomplianceInformation />}
                />
              </Route>
              <Route path="setup" element={<OrganizationalSetup />}>
                <Route index element={<Banking />} />
                <Route path="branch" element={<OrganizationalBranch />} />
                <Route path="department" element={<OrganizationDepartment />} />
                <Route path="designation" element={<OrganizationDesignation />} />
                <Route path="holiday" element={<HolidayManagement />} />
                <Route path="leave-management" element={<OrganizationLeave />} />
              </Route>
              <Route path="leave-policy" element={<OrganizationalLeavePolicy />}>
                <Route index  element={<OrganizationWeeklyOff />} />
                <Route path="full-time-employees" element={<OrganizationFullTimeEmployee openSnackbar={openSnackbar} />} />
                <Route path="part-time-employees" element={<OrganizationPartTimeEmployee openSnackbar={openSnackbar} />} />
                <Route path="probationary-employees" element={<OrganizationProbationaryEmployees openSnackbar={openSnackbar} />} />
                <Route path="contractual-employees" element={<OrganizationContractualEmployees openSnackbar={openSnackbar} />} />
              </Route>
              <Route path="employee-list" element={
                <EmployeeContextProvider>
                  <EmployeeList key={1} />
                </EmployeeContextProvider>} />
              <Route path="employee-onboarding" element={
                <EmployeeContextProvider>
                  <EmployeeList key={2} />
                </EmployeeContextProvider>} />
              <Route path="employee-permanent" element={
                <EmployeeContextProvider>
                  <EmployeeList key={3} />
                </EmployeeContextProvider>} />
              <Route path="employee-probation" element={
                <EmployeeContextProvider>
                  <EmployeeList key={4} />
                </EmployeeContextProvider>} />
              <Route path="employee-exit" element={
                <EmployeeContextProvider>
                  <EmployeeList key={5} />
                </EmployeeContextProvider>} />
              <Route path="employee-inactive" element={
                <EmployeeContextProvider>
                  <EmployeeList key={6} />
                </EmployeeContextProvider>} />
              <Route path="employee" element={<Employee />}>
                <Route
                  index
                  element={<EmployeeProfile />}
                />
                <Route
                  path=":id"
                  element={<EmployeeProfile />}
                />

                <Route
                  path="payAndBenefits/ui/:id"
                  element={<EmployeepayandAndBenefits />}
                />
                <Route
                  path="payAndBenefits/:id"
                  element={<PayAndBenefitsEmployee />}
                />
                <Route
                  path="statutoryKyc/:id"
                  element={<EmployeestatutoryKyc />}
                />
                <Route path="pay-kyc/:id" element={<EmployeePayKyc />} />
                <Route
                  path="beneficiary/:id"
                  element={<EmployeeBeneficiary />}
                />
                <Route
                  path="weekly-off/:id"
                  element={<EmpLeaveWeeklyOff />}
                />
                <Route
                  path="/employee/beneficiary/ui"
                  element={<BeneficiaryInfo />}
                />

                <Route
                  path="family-info/:id"
                  element={<FamilyInfo />}
                />

                <Route
                  path="exit-formaliti/:id"
                  element={<ExitFormaliti />}
                />
              </Route>
              <Route path="leave-manage" element={<EmployeeLeaveManage />}>
                <Route
                  index
                  element={<EmpLeaveInformation openSnackbar={openSnackbar} />}
                />
                <Route
                  path="leave-request"
                  element={<EmpLeaveRequest openSnackbar={openSnackbar} />}
                />
              </Route>

              <Route path="attendance" element={<Attendance openSnackbar={openSnackbar}/>} />
              <Route path="time-tracking" element={<TimeTracking />} />
              <Route path="overtime" element={<OtTracking openSnackbar={openSnackbar} />} />
              <Route path="loan-list" element={<Loan />} />
              <Route path="payroll" element={<Payroll />} />
              {/* Custom-report */}
              <Route path="salary-wages-report" element={<SalaryReport key={1}/>} />
              <Route path="salary-report" element={<SalaryReport key={2}/>} />
              <Route path="wages-report" element={<SalaryReport key={3}/>} />
              <Route path="pay-slip-report" element={<PayslipReport />} />
              <Route path="p-tax-report" element={<PtaxReport />} />
              <Route path="attendance-report" element={<AttendanceReport />} />
              <Route path="epf-report" element={<EpfReport />} />
              <Route path="esi-report" element={<EsiReport />} />
              <Route path="pay-acquiescent-report" element={<BankDisbursmentReport />} />
              {/* Custom-report */}
            </Route>

            <Route path="/" element={<LayoutFull />}>
              <Route path="/onboarding" element={<OnBoarding />} />
            </Route>

            {/* Details-Route */}
            
            <Route
              path="/organization-details"
              element={<OrganizationDetails />}
            >
              <Route index element={<OrgPersonalDetails />} />

              <Route
                path="/organization-details/ownership-info"
                element={<OrgOwnershipInfo />}
              />
              <Route
                path="/organization-details/branch-info"
                element={<OrgBranchInfo />}
              />

              <Route
                path="/organization-details/allowance-info"
                element={<OrgAllowanceInfo />}
              />
              <Route
                path="/organization-details/leave-details"
                element={<OrgLeavesInfo />}
              />
              <Route
                path="/organization-details/holiday-info"
                element={<OrgHolidayDetails />}
              />
            </Route>
            <Route path="/statutory-details" element={<StatutoryDetails />}>
              <Route
                index
                path="/statutory-details/epf"
                element={<StatutoryEpfDetails />}
              />
              <Route
                path="/statutory-details/esi"
                element={<StatutoryEsiDetails />}
              />

              <Route
                path="/statutory-details/gratuity-act"
                element={<StatutoryGratuityActDetails />}
              />

              <Route
                path="/statutory-details/p-tax-status"
                element={<StatutoryPtaxStatusDetails />}
              />

              <Route
                path="/statutory-details/compliance"
                element={<StatutoryComplianceDetails />}
              />

              <Route
                path="/statutory-details/banking-and-finance"
                element={<StatutoryBankDetails />}
              />

              <Route
                path="/statutory-details/labour-welfare-fund"
                element={<StatutoryLabourWelfareFundDetails />}
              />
            </Route>
            {/* Details-Route */}
          </Route>
          {/* Admin-Route */}
          <Route path="/admin" element={<ProtectedRouteAdmin><AdminLayout /></ProtectedRouteAdmin>}>
            <Route index element={<AdminDashboard />} />
            <Route path="organization-list" element={<AdminOrganizationList openSnackbar={openSnackbar} />} />
            <Route path="organization-table" element={<OrganizationTableView openSnackbar={openSnackbar} />} />
            <Route path="add-organization" element={<AdminOrganizationAdd openSnackbar={openSnackbar} />} />
            <Route path="organization/:orgId" element={<OrganizationView />}>
               <Route
                  index
                  element={<OrganizationProfileForAdmin />}
                /> 
                <Route
                  path="ownership"
                  element={<OrganizationOwnershipForAdmin />}
                />
                <Route
                  path="allowance"
                  element={<OrganizationAllowaanceForAdmin />}
                /> 
                <Route
                  path="benefits"
                  element={<OrganizationBenefitAdmin />}
                /> 
                <Route
                  path="access"
                  element={<OrganizationAccessAdmin />}
                /> 
                
              </Route>
            {/* Settings-Route */}
            <Route path="settings" element={<AdminSettings />}>
              {/* <Route
                // path="allowance-data"
                index
                element={<AdminAllowanceData openSnackbar={openSnackbar} />}
              /> */}
              <Route
                index
                element={<AdminAllowanceData openSnackbar={openSnackbar} />}
              />
              <Route
                path="holiday-management"
                element={<AdminHolidayManagement openSnackbar={openSnackbar} />}
              />
              <Route
                path="p-tax"
                element={<AdminPTax openSnackbar={openSnackbar} />}
              />
              <Route
                path="labour-welfare-fund"
                element={<AdminLabourWelfareFund openSnackbar={openSnackbar} />}
              />
              <Route
                path="esi-contribution"
                element={<AdminEsiContribution openSnackbar={openSnackbar} />}
              />
              <Route
                path="leave-management"
                element={<AdminLeaveManagement openSnackbar={openSnackbar} />}
              />
            </Route>
            {/* Settings-Route */}
          </Route>
          {/* Admin-Route */}

          {/* Employee-Portal-Route */}
          <Route path="/employee-portal" element={<EmployeePortalLayout />}>
            <Route index element={<EmployeePortalDashboard />} />
            {/* My-profile */}
            <Route path="my-profile" element={<MyProfile />}>
              <Route
                index
                path="about-me"
                element={<AboutMe />}
              />
              <Route
                index
                element={<AboutMe />}
              />
              <Route
                path="job-description"
                element={<JobDescription />}
              />
              <Route
                path="bank-account"
                element={<BankAccount />}
              />
              <Route
                path="nominee"
                element={<Nominee />}
              />
              <Route
                path="family-details"
                element={<FamilyDetails />}
              />
            </Route>
            {/* My-profile */}
            <Route path="salary-structure" element={<EmPortalSalaryStructure />} />
            <Route path="payslips" element={<EmPortalPayslip />} />
            <Route path="leave" element={<EmPortalLeave />} />
            <Route path="holiday" element={<EmPortalHoliday />} />
          </Route>
          {/* Employee-Portal-Route */}
        </Routes>
      </Suspense>

      <Snackbar
        message={snackbarMessage}
        color={snackColor}
        variant="contained"
        size="medium"
        position="top-right"
        onClose={
          closeSnackbar}
        onOpen={snackbarVisible}
        loading={false}
        duration={3000}
      />
    </>
  );
}

export default AppRouter;
